function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M25 23H0V0h25z",
  fill: "#695041"
}), React.createElement("path", {
  d: "M0 39V20h11z",
  fill: "#695041"
}), React.createElement("path", {
  d: "M7 5h7.062C16.076 5 18 6.077 18 9.039c0 2.647-1.63 4.078-4.543 4.078h-5.1V19H7zm1.356 6.784h5.239c2.272 0 2.932-1.117 2.932-2.749 0-2.097-1.1-2.705-2.656-2.705H8.356z",
  fill: "#fff"
}));

var SvgMapMarkerParking = function SvgMapMarkerParking(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 25 39"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMzkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSI+PHBhdGggZD0ibTI1IDIzaC0xNS4xMTc0NDYzLTQuODUwMDk3MDMtNS4wMzI0NTY2N3YtMjNoMjV6IiBmaWxsPSIjNjk1MDQxIi8+PHBhdGggZD0ibTAgMzl2LTE5aDExeiIgZmlsbD0iIzY5NTA0MSIvPjxwYXRoIGQ9Im03IDVoNy4wNjE1Njk5YzIuMDE0MTUyMyAwIDMuOTM4NDMwMSAxLjA3NzA1NTIxIDMuOTM4NDMwMSA0LjAzODUyNzYxIDAgMi42NDcxMTY1OS0xLjYzMDU4MDcgNC4wNzgwMzY3OS00LjU0MzQ3ODMgNC4wNzgwMzY3OWgtNS4xMDAzNzkzdjUuODgzNDM1NmgtMS4zNTYxNDI0em0xLjM1NjE0MjQgNi43ODM1NTgzaDUuMjM4NDAwOWMyLjI3MjU0MTYgMCAyLjkzMjE1NjQtMS4xMTY1NjQ0IDIuOTMyMTU2NC0yLjc0ODQ2NjI4IDAtMi4wOTc0MjMzMS0xLjA5OTM1OC0yLjcwNTUyMTQ3LTIuNjU2MTEzMi0yLjcwNTUyMTQ3aC01LjUxNDQ0NDF6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==";
export { SvgMapMarkerParking as ReactComponent };